import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "dropdownMenu", "form", "submitButton"];

  connect() {
    this.outsideClickListener = this.handleOutsideClick.bind(this);
    document.addEventListener("click", this.outsideClickListener);
    this.toggleButton();
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClickListener);
  }

  selectAll() {
    this.checkboxTargets.forEach(checkbox => checkbox.checked = true);
    this.toggleButton();
  }

  reset() {
    this.checkboxTargets.forEach(checkbox => checkbox.checked = false);
    this.toggleButton();
  }

  toggle() {
    this.dropdownMenuTarget.classList.toggle("hidden");
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownMenuTarget.classList.add("hidden");
    }
  }

  toggleButton() {
    const isAnyChecked = this.checkboxTargets.some(checkbox => checkbox.checked);
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !isAnyChecked;
    }
  }

  submit(event) {
    event.preventDefault();

    const formElement = this.hasFormTarget ? this.formTarget : this.element.querySelector("form");
    if (!formElement) return;

    const formData = new FormData(formElement);
    const queryString = new URLSearchParams(formData).toString();
    const pathName = window.location.pathname;

    const url = queryString ? `${pathName}?${queryString}` : pathName;
    window.history.pushState({}, '', url);

    formElement.requestSubmit();
  }
}
